import { XCircleIcon } from "lucide-react";
import styles from "./CuriosityDisclaimer.module.scss";

interface CuriosityDisclaimerProps {
	isOpen: boolean;
	onClose: () => void;
}

export const CuriosityDisclaimer = ({
	isOpen,
	onClose,
}: CuriosityDisclaimerProps) => {
	return (
		<>
			{isOpen && (
				<div className={styles.curiosityDisclaimer}>
					<p className={styles.curiosityDisclaimer__title}>
						AI is not a substitute for your expertise.&nbsp;&nbsp;|&nbsp;&nbsp;
						Always check your answers and references thoroughly.
					</p>
					<button
						type="button"
						className={styles.curiosityDisclaimer__button}
						onClick={onClose}
						aria-label="Close Curiosity disclaimer"
					>
						<XCircleIcon width={21} height={21} />
					</button>
				</div>
			)}
		</>
	);
};
